import { ChurchUnit } from '../ecclesiastical/church-unit.model';

export class HomeUnitChange {
    iNumber: string;
    oldHomeUnit: ChurchUnit;
    newHomeUnit: ChurchUnit;
    updatedBy: string;
    updatedOn: Date;
}
